// Generated by scripts/marina-tokens.mjs from docs/design/marina-system/tokens.json (Neomaris Marina 1.0.0, sha256 bca432d7e33bc4a93699303b7dbc97ac18ff8f120cf622df3ac6f59ae45c4ce1). Do not edit: change tokens.json and run `node scripts/marina-tokens.mjs` (cloud ADR 0396).
//
// marinaThemes: themes.js's Light and Dark palettes (Night stays hand-kept,
// ADR 0393 §5). marinaAccent: the coral accent. marinaSeries: --tc-series-1
// to 4. marinaKinds: the colour of each kind of reading, every look, as
// page.js writes --tc-<kind>. marinaPageCards: the card the page check paints
// under a page, the lightest point of the card's glass.

export const MARINA_VERSION = "1.0.0";
export const MARINA_SHA256 =
  "bca432d7e33bc4a93699303b7dbc97ac18ff8f120cf622df3ac6f59ae45c4ce1";

export const marinaThemes = {
  light: {
    canvas: "#f2f3f7",
    background: "#ffffff",
    surface: "#f4f5f8",
    text: "#070d19",
    muted: "#536175",
    quiet: "#5f6d81",
    grid: "rgba(84,112,134,.14)",
    track: "#e3e8ed",
    good: "#197e3a",
    attention: "#936000",
    danger: "#b52e29",
    sky: "#d9e2e7",
    earth: "#d9c3b5",
  },
  dark: {
    canvas: "#020f18",
    background: "#0a1d28",
    surface: "#132b38",
    text: "#ffffff",
    muted: "#c9d4de",
    quiet: "#a8bac9",
    grid: "rgba(190,216,232,.16)",
    track: "#2e424e",
    good: "#49da8a",
    attention: "#f5ce7e",
    danger: "#ffaaa0",
    sky: "#34373c",
    earth: "#50403a",
  },
};

export const marinaAccent = { light: "#b6472d", dark: "#ff9d7d" };

export const marinaSeries = {
  light: ["#b6472d", "#070d19", "#5f6d81", "#5f6d81"],
  dark: ["#ff9d7d", "#ffffff", "#a8bac9", "#a8bac9"],
};

export const marinaKinds = {
  light: {
    power: {
      line: "#169a24",
      fill: "#44ad64",
      fillTop: 0.38,
      fillBottom: 0.1,
      icon: "#169a24",
    },
    water: {
      line: "#0088bf",
      fill: "#168bc1",
      fillTop: 0.52,
      fillBottom: 0.12,
      icon: "#00a5d3",
    },
    fuel: {
      line: "#bd431e",
      fill: "#c74927",
      fillTop: 0.44,
      fillBottom: 0.1,
      icon: "#bd431e",
    },
    weather: {
      line: "#1a9fce",
      fill: "#239dcf",
      fillTop: 0.3,
      fillBottom: 0,
      icon: "#1a9fce",
    },
    wind: {
      line: "#6b4fd8",
      fill: "#8a72e6",
      fillTop: 0.3,
      fillBottom: 0.06,
      icon: "#6b4fd8",
    },
    depth: {
      line: "#0088bf",
      fill: "#168bc1",
      fillTop: 0.52,
      fillBottom: 0.12,
      icon: "#00a5d3",
    },
    navigation: {
      line: "#b8326f",
      fill: "#c94d86",
      fillTop: 0.3,
      fillBottom: 0.06,
      icon: "#b8326f",
    },
    engine: {
      line: "#a8650a",
      fill: "#c07a1c",
      fillTop: 0.34,
      fillBottom: 0.08,
      icon: "#a8650a",
    },
  },
  dark: {
    power: {
      line: "#2ce48b",
      fill: "#33d58f",
      fillTop: 0.42,
      fillBottom: 0.06,
      icon: "#2ce48b",
    },
    water: {
      line: "#11d7ed",
      fill: "#11d7ed",
      fillTop: 0.38,
      fillBottom: 0.08,
      icon: "#11d7ed",
    },
    fuel: {
      line: "#f2673b",
      fill: "#e76b3d",
      fillTop: 0.36,
      fillBottom: 0.05,
      icon: "#f2673b",
    },
    weather: {
      line: "#11b4df",
      fill: "#12a6d0",
      fillTop: 0.32,
      fillBottom: 0,
      icon: "#11b4df",
    },
    wind: {
      line: "#ad97ff",
      fill: "#9c86f5",
      fillTop: 0.34,
      fillBottom: 0.05,
      icon: "#ad97ff",
    },
    depth: {
      line: "#11d7ed",
      fill: "#11d7ed",
      fillTop: 0.38,
      fillBottom: 0.08,
      icon: "#11d7ed",
    },
    navigation: {
      line: "#ff73b0",
      fill: "#f565a4",
      fillTop: 0.32,
      fillBottom: 0.05,
      icon: "#ff73b0",
    },
    engine: {
      line: "#f5b23e",
      fill: "#e9a532",
      fillTop: 0.32,
      fillBottom: 0.05,
      icon: "#f5b23e",
    },
  },
  night: {
    power: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    water: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    fuel: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    weather: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    wind: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    depth: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    navigation: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
    engine: {
      line: "#d95a45",
      fill: "#d95a45",
      fillTop: 0.18,
      fillBottom: 0.03,
      icon: "#d95a45",
    },
  },
};

export const marinaPageCards = {
  light: "#ffffff",
  dark: "#364651",
  night: "#1e0604",
};
